import {TTrack} from "../types";
import styled from "styled-components";
import spotify from "../assets/Spotify_Logo_RGB_Green.png";
import {DateTime} from 'luxon';

export type TrackProps = {
    track: TTrack,
    onClick?: () => void,
};


export const ImageContainer = styled.div`
    margin-top: auto;
    margin-bottom: auto;
`;

export const TrackInfoContainer = styled.div`
    position: relative;

    margin-top: auto;
    margin-bottom: auto;
    padding-left: 1rem;
    text-align: left;
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;

    width: 20rem;

    background: ${props => props.theme.palette.common.white};
    border-radius: 0 5px 5px 0;

    /* Phones */
    @media only screen and (max-width: 767px) {
        width: 13rem;
    }
`;

export const AlbumImage = styled.img`
`;

export const SpotifyImage = styled.img`
`;

export const TrackContainer = styled.li`
    list-style-type: none;
    padding-inline-start: unset;
    display: flex;
    margin-bottom: 1rem;

    color: ${props => props.theme.palette.common.black};

    &:hover {
        cursor: pointer;
    }

    &:hover ${TrackInfoContainer} {
        background-color: ${props => props.theme.palette.secondary.lightest};
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    }
`;

export const TrackName = styled.h5`
    margin-top: 0;
    margin-bottom: 0;
    line-height: 0.8rem;
    width: 23ch;
`;

export const ArtistsNames = styled.h6`
    margin-bottom: 0;
    margin-top: 0.5rem;
    line-height: 0.8rem;
    width: 23ch;
`;

export const TimeAgo = styled.h6`
    font-weight: 200;
    margin-bottom: 0;
    margin-top: 0.5rem;
    line-height: 0.2rem;
    width: 23ch;
`;

function getArtistNames(track: TTrack) {
    return track?.artists?.map(artist => artist?.name).join(", ");
};

function getRelativeCalendar(track: TTrack): string | null {
    if (!track?.date) return null;
    const trackDate = DateTime.fromISO(track.date as string);

    const dateDiff = DateTime.now().diff(trackDate, "minutes");
    const wasWithinOneHour = dateDiff.toObject().minutes as number < 60;

    return trackDate.toRelativeCalendar({unit: wasWithinOneHour ? "minutes" : "days", locale: "en"});
}

function Track(props: TrackProps) {
    const {track, onClick} = props;
    const {name, album, url, date} = track;

    const imageUrl = album?.images?.[2].url;

    const handleClick = () => {
        if (onClick) onClick();
        if (url) window.open(url, "_blank");
    };

    const timeAgo = getRelativeCalendar(track);

    return (
        <TrackContainer onClick={handleClick}>
            <ImageContainer>
                <AlbumImage height={90} alt="album cover" src={imageUrl}/>
            </ImageContainer>
            <TrackInfoContainer>
                <SpotifyImage alt="spotify logo" width={70} src={spotify}/>
                <TrackName>{name}</TrackName>
                <ArtistsNames>{getArtistNames(track)}</ArtistsNames>
                {timeAgo && (
                    <TimeAgo>
                        {timeAgo}
                    </TimeAgo>
                )}


            </TrackInfoContainer>
        </TrackContainer>
    );
}

export default Track;
